import { ReactSVG } from "react-svg";
import Logo from "../Logo";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useCookies } from "react-cookie";
import { RESTE_ALL_AUTH_DATA } from "../../../../redux/action/auth/type";
import axios from "axios";

const Header = ({ logout }) => {

    const dispatch = useDispatch()

    const navigate = useNavigate();

    const [cookies, setCookies, removeCookie] = useCookies()

    const handleLogout = async () => {
        try {
            // 1️⃣ درخواست logout به سرور
            const res = await axios.post(
                "https://my-sarad-back.liara.run/api/auth/logout",
                {refreshToken: cookies.refreshToken}
            );

            // اگر پاسخ موفق بود
            if (res.status === 200) {
            
                console.log("Server logout successful ✅");
             
            }

        } catch (error) {
        
            console.error("Logout API error:", error.response?.data?.message || error.message);
        
        } finally {
            // 2️⃣ حذف کوکی (در صورتی که HttpOnly نباشد)
            removeCookie("refreshToken", { path: "/" });

            // 3️⃣ پاک کردن داده‌های محلی
            localStorage.removeItem("otp");

            dispatch({
                type: RESTE_ALL_AUTH_DATA,
            })

            // 4️⃣ هدایت به صفحه احراز هویت
            navigate("/auth");
        }
    };

    return (
        <header className="h-16 bg-white border-b flex items-center md:justify-end justify-between px-6">
            
            <div className="md:hidden">
                <Logo />
            </div>

            <button
                onClick={handleLogout}
                className="
                text-sm
                text-slate-600
                hover:text-red-500
                transition
                flex items-center gap-1
                "
            >
                <ReactSVG src={`${process.env.PUBLIC_URL}/assets/images/icons/logout.svg`} className="w-5 h-5"/>
                
                خروج از حساب

            </button>

        </header>
    );

};

export default Header